<template>
    <div class="af-searchbar-container">
        <div class="af-searchbar-inner-container afu-flex afu-flex-row afu-mb-6">
            <div class="afu-w-30p">
                <div class="af-keyword-search afu-block afu-border afu-box-border afu-border-solid afu-border-r-0 afu-appearance-none afu-transition afu-duration-150 afu-ease-in-out afu-text-black afu-border-inputBorder-400 focus:afu-border-inputBorder-600 afu-bg-white afu-p-sb-input afu-h-full">
                    <div class="label-wrapper afu-mb-0 af-text--5xl afu-text-secondary afu-font-semibold">
                        <span class="afu-font-bold afu-tracking-widest afu-uppercase">{{ $t('searchbar.keywords_label') }}</span>
                    </div>
                    <input
                        class="afu-border-none afu-w-full focus:afu-outline-none afu-placeholder-custom afu-text-6xl afu-font-normal afu-p-0 afu-pt-1"
                        name="search-keywork-input"
                        v-model="keyword"
                        :placeholder="$t('label.search_keyword')"
                        @keyup.enter="handleSearch()"
                    >
                </div>
            </div>
            <div class="afu-w-30p">
                <ClassificationSelecter
                    :init-classifications="classifications"
                    :close-dropdown="closeClassificationDropdown"
                    @updateClassification="searchClassification"
                />
            </div>
            <div class="afu-w-40p afu-flex afu-justify-end">
                <div class="afu-relative af-location-search afu-block afu-border afu-border-solid afu-border-l-0 afu-appearance-none afu-w-2/3 afu-transition afu-duration-150 afu-ease-in-out afu-text-black afu-border-inputBorder-400 focus:afu-border-inputBorder-600 afu-bg-white afu-p-sb-input afu-mr-1">
                    <div class="label-wrapper afu-mb-0 af-text--5xl afu-text-secondary afu-font-semibold">
                        <span class="afu-font-bold afu-tracking-widest afu-uppercase">{{ $t('searchbar.locations_label') }}</span> 
                    </div>
                    <C1Typeahead
                        v-model="location.label"
                        class="searchbar-typeahead w-100 afu-border-none"
                        naked
                        size="naked"
                        :search-min-length="2"
                        :is-busy="spinner.location"
                        :options="locationOptions"
                        :no-icon="true"
                        label-key="label"
                        value-key="id"
                        filter-by="label"
                        :placeholder="$t('label.select_location')"
                        @search="searchLocations"
                        @hit="onLocationSelect"
                        @keyup.enter="handleSearch()"
                    >
                        <template
                            slot="noResults"
                        >
                            <div>
                                No matching locations found.
                            </div>
                        </template>
                    </C1Typeahead>
                </div>
                <div class="afu-w-1/3">
                    <C1Button
                        type="button"
                        variant="primary"
                        size="lg"
                        class="search-submit af-text--7xl afu-w-full afu-h-full"
                        @click.prevent="handleSearch()"
                    >
                        {{ $t('label.search_jobs') }}
                    </C1Button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SearchBarMixin from '@/apps/search/001/components/Mixins/SearchBarMixin';

    export default {
        name: 'SearchBar',

        mixins: [SearchBarMixin],

        data() {
            return {
                locationOptions: [],
                searchResults: [],
                searchQuery: {
                    location: '',
                    classification: [],
                    keyword: '',
                },
                spinner: {
                    location: false,
                },
            };
        },
    };
</script>

<style lang="scss">
    .searchbar-typeahead {
        .af-input-naked {
            padding-right: 26px;
            text-overflow: ellipsis;
        }
    }
</style>